export type AllowedAssignment = 'active' | 'review' | '';

export function isAllowedAssignment(assignment: string): assignment is AllowedAssignment {
  return assignment === 'active' || assignment === 'review';
}
